// extracted by mini-css-extract-plugin
module.exports = {"EventWrapper":"Events_EventWrapper__2R9Og"};